import { render, staticRenderFns } from "./ProfileWall.vue?vue&type=template&id=00d05170&"
import script from "./ProfileWall.vue?vue&type=script&lang=js&"
export * from "./ProfileWall.vue?vue&type=script&lang=js&"
import style0 from "./ProfileWall.vue?vue&type=style&index=0&id=00d05170&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports